export default "__VITE_ASSET__d818cdad__"